export const createDataEntryRouteWithStep = (step: number) => `${DATA_ENTRY_KEY}/${step}`;

export const createPathForRoute = (path: string) => {
  return `/${B2C_BASE_ROUTE}/${path}`;
};

export const B2C_BASE_ROUTE = 'b2c';

export const DATA_ENTRY_KEY = 'data-entry';
export const WELCOME_KEY = 'welcome';
export const THANKS_KEY = 'thanks';
export const CARRIER_KEY = 'carrier';
export const SETUP_KEY = 'setup';
export const RECAP_KEY = 'recap';

const WELCOME_ROUTE = `${WELCOME_KEY}/:username/:token`;

// DATA ENTRY STEPS
const DATA_ENTRY_FIRST_STEP_ROUTE = createDataEntryRouteWithStep(1);
const DATA_ENTRY_SECOND_STEP_ROUTE = createDataEntryRouteWithStep(2);
const DATA_ENTRY_THIRD_STEP_ROUTE = createDataEntryRouteWithStep(3);
const DATA_ENTRY_FOURTH_STEP_ROUTE = createDataEntryRouteWithStep(4);
const DATA_ENTRY_FIFTH_STEP_ROUTE = createDataEntryRouteWithStep(5);
const DATA_ENTRY_SIXTH_STEP_ROUTE = createDataEntryRouteWithStep(6);
const DATA_ENTRY_SEVENTH_STEP_ROUTE = createDataEntryRouteWithStep(7);
const DATA_ENTRY_EIGHTH_STEP_ROUTE = createDataEntryRouteWithStep(8);

const RECAP_ROUTE = RECAP_KEY;
const CARRIER_ROUTE = CARRIER_KEY;
const THANKS_ROUTE = `${THANKS_KEY}/:pdf?`;

const SETUP_ROUTE = `${SETUP_KEY}/:pazienteId/:secretGdSuiteCode`;

export {
  CARRIER_ROUTE,
  DATA_ENTRY_EIGHTH_STEP_ROUTE,
  DATA_ENTRY_FIFTH_STEP_ROUTE,
  DATA_ENTRY_FIRST_STEP_ROUTE,
  DATA_ENTRY_FOURTH_STEP_ROUTE,
  DATA_ENTRY_SECOND_STEP_ROUTE,
  DATA_ENTRY_SEVENTH_STEP_ROUTE,
  DATA_ENTRY_SIXTH_STEP_ROUTE,
  DATA_ENTRY_THIRD_STEP_ROUTE,
  RECAP_ROUTE,
  THANKS_ROUTE,
  WELCOME_ROUTE,
  SETUP_ROUTE,
};
